import { FormikErrors } from "formik";

interface showErrorsProps {
  errors: FormikErrors<unknown>;
}

const useShowFormikErrors = ({ errors }: showErrorsProps) => {
  const getInvalidFieldsMessage = () => {
    const messages: string[] = [];
    for (const key in errors) {
      messages.push(`${key}: ${errors[key as keyof typeof errors]}`);
    }
    return messages.join("\n");
  };

  const showErrors = Object.keys(errors).length > 0;
  const tooltipMessage = showErrors ? getInvalidFieldsMessage() : "";
  return {
    tooltipMessage,
  };
};

export default useShowFormikErrors;
